import { CommonModule } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CompletarGestionService } from './completar-gestion.service';
import { Tarea } from 'app/models/tareas.model';
import { DocumentoGenerado } from 'app/modules/admin/bienes-culturales/detalle-bien-cultural/tabs/documentos-emitidos/models/response-documento-generado';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { DocumentIconComponent } from "app/modules/GlobalComponents/document-icon.component";
import { StatusStickerComponent } from "app/modules/GlobalComponents/status sticker.component";
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { UtilsService } from 'app/modules/utils-service';
import { CompletarGestionInterface } from 'app/models/completar-gestion.model';
import { DetalleTareaService } from 'app/modules/admin/detalle-tareas/detalle-tareas-service';
import { ArchivosSubidosService } from '../archivos-subidos/archivos-subidos.service';

@Component({
    selector: 'modal-completar-gestion',
    templateUrl: 'completar-gestion.component.html',
    imports: [
    CommonModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    DocumentIconComponent,
    MatRadioModule,
    FormsModule,
    //componentes
    DocumentIconComponent,
    StatusStickerComponent
]
})

export class CompletarGestionComponent implements OnInit {
    @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
    detalleTarea: Tarea
    documentosGenerados:DocumentoGenerado[]= []
    isDraggingOver = false;
    documentos: File[] = [];
    documentoSeleccionado:DocumentoGenerado
    uuidDocumentoOficial:string
    nombreDocumentoSeleccionado:string

    constructor(
        public dialogRef: MatDialogRef<CompletarGestionComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Tarea,
        private completarGestionService:CompletarGestionService,
        private _detalleTareasService: DetalleTareaService,
        private utilsService: UtilsService,
        private archivosSubidosService: ArchivosSubidosService
    ) { 
        this.detalleTarea= this.data    
        this.getDocumentos()
    }
    

    ngOnInit() { }

    getDocumentos(){
        this.completarGestionService.getListaDocumentoOficial(this.detalleTarea.tareaUuid)
        .then((response:DocumentoGenerado[])=>{
            this.documentosGenerados= response
        })
    }

    uploadImage() {
        this.fileInput.nativeElement.click();
    }

    onDragOver(event: DragEvent) {
        event.preventDefault();
        this.isDraggingOver = true;
    }

    onDragLeave(event: DragEvent) {
        event.preventDefault();
        this.isDraggingOver = false;
    }

    onDrop(event: DragEvent) {
        event.preventDefault();
        this.isDraggingOver = false;
        if (event.dataTransfer?.files.length > 0) {
        this.handleFiles(event.dataTransfer.files);
        }
    }

    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files?.length) {
        this.handleFiles(input.files);
        }
    }

    handleFiles(files: FileList) {
        const formData = new FormData();
    
        if (files.length > 0) {
            this.nombreDocumentoSeleccionado = files[0].name;
        }

        Array.from(files).forEach(file => {
            formData.append('files', file);
            formData.append('documentoOficial', 'true');
        });

        this.completarGestionService.postDocumentosGestion(formData, this.detalleTarea.tareaUuid)
        .then((response: any)=>{
            this.uuidDocumentoOficial= response.data
        })
    }

    completarGestion(){
        let body: CompletarGestionInterface = {
            gestionUuid: this.detalleTarea.tareaUuid,
            documentoFirmado:this.uuidDocumentoOficial,
            documentoCertificado:this.documentoSeleccionado.documentoGeneradoUuid,
        }

        this.completarGestionService.postAprobarGestion(body)
        .then((response: any)=>{
            this.dialogRef.close(false)
            this._detalleTareasService.getActividadesByTask(this.detalleTarea.tareaUuid)
            this._detalleTareasService.getTaskDetails(this.detalleTarea.tareaUuid)
            this.archivosSubidosService.getArchivosByEntity(this.detalleTarea.tareaUuid),
            this.utilsService.openSuccessSnakBar('La gestión se ha completado correctamente.')
        })
    
    }

}